import * as WholeSalePlanned from './wholeSalePlanned';

const Actions = {
  ...WholeSalePlanned,
};

export default Actions;
